import { Action } from '../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../helpers';
import {
  NotificationsPreference,
  NotificationsPreferenceApiResponseItem,
} from './notification-preferences.model';

export function notificationsUserPreferencesReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'notificationsUserPreferences') {
        const { result, refList } = action.payload;
        return mergeEntities<'notificationsUserPreferences'>(
          state,
          transformObjects(result, transformNotificationsUserPreferences),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    case 'API_SET_SUCCESS': {
      if (action.payload.type === 'notificationsUserPreferences') {
        const { result, ref } = action.payload;
        return mergeEntities<'notificationsUserPreferences'>(
          state,
          transformObjects(result, transformNotificationsUserPreferences),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}

function transformNotificationsUserPreferences(
  setting: NotificationsPreferenceApiResponseItem,
): NotificationsPreference {
  return {
    id: setting.channel,
    channel: setting.channel,
    name: setting.name,
    order: setting.order,
    enabled: setting.enabled,
    notify: setting.notify,
    header: setting.header,
    notificationType: setting.notificationType,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/datastore/notification-preferences/notification-preferences.reducer.ts